import { TTicket } from '../ticket/types';

export const TICKETS_SET_TICKETS = 'TICKETS_SET_TICKETS';
export const TICKETS_SET_SEARCH_STRING = 'TICKETS_SET_SEARCH_STRING';
export const TICKETS_TOGGLE_LOADING = 'TICKETS_TOGGLE_LOADING';
export const TICKETS_TOGGLE_NEW_TICKET_DROPDOWN = 'TICKETS_TOGGLE_NEW_TICKET_DROPDOWN';
export const TICKETS_RESET_STORE = 'TICKETS_RESET_STORE';
export const TICKETS_SET_FILTER_STRING = 'TICKETS_SET_FILTER_STRING';
export const TICKETS_TOGGLE_FILTER_DROPDOWN = 'TICKETS_TOGGLE_FILTER_DROPDOWN';
export const TICKETS_ADD_TICKET_TO_TICKETS = 'TICKETS_ADD_TICKET_TO_TICKETS';
export const TICKETS_ESCALATE_TICKET = 'TICKETS_ESCALATE_TICKET';

export interface IAddTicketToTicketsAction {
  type: typeof TICKETS_ADD_TICKET_TO_TICKETS;
  theTicket: TTicket;

}
export interface ITogglTicketsFilterDropdownAction {
  type: typeof TICKETS_TOGGLE_FILTER_DROPDOWN;
}

export interface ITicketsSetFilter {
  type: typeof TICKETS_SET_FILTER_STRING;
  payload: string;

}

export interface ITicketsState {
  loading: boolean;
  openNewTicketDropdown: boolean;
  searchString: string;
  tickets: TTicket[];
  openFilterTicketsDropdown: boolean;
  visibleState: string;

}

export interface ITicketsResetStore {
  type: typeof TICKETS_RESET_STORE;
}

interface ISetAccountTicketsAction {
  type: typeof TICKETS_SET_TICKETS;
  tickets: TTicket[];
}

interface ISetAccountTicketsSearchAction {
  type: typeof TICKETS_SET_SEARCH_STRING;
  search: string;
}

interface IToggleAccountTicketsLoadingAction {
  type: typeof TICKETS_TOGGLE_LOADING;
}

interface IToggleNewTicketsDropdownAction {
  type: typeof TICKETS_TOGGLE_NEW_TICKET_DROPDOWN;
}

interface IEscalateTicketAction {
  type: typeof TICKETS_ESCALATE_TICKET;
  id: string;
}
export type TicketsActionTypes =
    IAddTicketToTicketsAction |
    ISetAccountTicketsAction |
    ISetAccountTicketsSearchAction |
    IToggleAccountTicketsLoadingAction |
    IToggleNewTicketsDropdownAction |
    ITicketsResetStore |
    ITicketsSetFilter |
    ITogglTicketsFilterDropdownAction |
    IEscalateTicketAction;
